import { formatMoney } from "./format";

/* Bring Your Buyers wording shared by Payouts, Sales and the user dialog.
 * A seller's own buyers pay 0% Inflos fee on their first 10 plants; an order
 * that crosses the 10 pays the fee only on the plants past it. The seller
 * pays the buyer's S$5 welcome voucher out of their earnings (seller_profit
 * is already net of it). */

export type FeeReason = "standard" | "brought_buyer" | "brought_buyer_partial" | string | null | undefined;

export const PILOT_EXPLAINER =
  "Seller sees the Your buyers card; their link and code give new buyers S$5 off (paid by the seller) and 0% commission on their first 10 plants.";

export const isBroughtBuyer = (reason: FeeReason) => reason === "brought_buyer" || reason === "brought_buyer_partial";

const pct = (rate: number) => `${(Math.round(rate * 1000) / 10).toString()}%`;

/** "Inflos fee · 10%", "Inflos fee · 0% · their buyer", "Inflos fee · part at 0% · their buyer". */
export function feeLabel(reason: FeeReason, rate?: number | null): string {
  if (reason === "brought_buyer") return "Inflos fee · 0% · their buyer";
  if (reason === "brought_buyer_partial") return "Inflos fee · part at 0% · their buyer";
  return rate === null || rate === undefined ? "Inflos fee" : `Inflos fee · ${pct(rate)}`;
}

/** Shorter form for tight spots (a caption under a number). */
export function feeNote(reason: FeeReason): string | null {
  if (reason === "brought_buyer") return "0% · their buyer";
  if (reason === "brought_buyer_partial") return "part at 0% · their buyer";
  return null;
}

/** "−S$5.00": an amount taken off, with a real minus sign. */
export const minusMoney = (amount: number, currency: string) => `−${formatMoney(Math.abs(amount), currency)}`;

export const WELCOME_VOUCHER = "Welcome voucher";
